import { render } from "./dgMailSignatureGenerator.vue?vue&type=template&id=4346b659"
import script from "./dgMailSignatureGenerator.vue?vue&type=script&lang=js"
export * from "./dgMailSignatureGenerator.vue?vue&type=script&lang=js"

import "./dgMailSignatureGenerator.vue?vue&type=style&index=0&id=4346b659&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__